import React from "react"
import Modal from "../Modal"
import { useSignInStore } from "@/stores"
import { cdnPublicFolderUrl } from "@/constants"

const NewUserRewardModal = () => {
  const { setSignInModal, signInModal } = useSignInStore()

  return (
    <Modal
      closeButtonClassName="absolute top-2 right-2 z-[1] text-white"
      className="bg-[#191918] rounded-xl max-w-xl shadow-md p-4"
      bodyClassName="p-0"
      containerClassName={"overflow-auto"}
      isOpen={!!signInModal.newUser}
      onClose={() => setSignInModal({ newUser: false })}
    >
      <div className="flex flex-col items-center py-6">
        <div className="flex items-center space-x-4 mb-6">
          <img src={`${cdnPublicFolderUrl}/av-coin.png`} alt="" />
          <div>
            <p className="font-semibold text-xl">+1000</p>
            <p className="ml-1">AV COINS</p>
          </div>
        </div>
        <h2 className="text-3xl font-semibold mb-6">Welcome new GAIA</h2>
        <p className="text-center max-w-[23rem]">
          You have received 1000 AV Coins for your artistic journey on GAIA.
          <br /> Happy crafting! 🖌️✨
        </p>
      </div>
    </Modal>
  )
}

export default NewUserRewardModal
